const messages = {
	en: {
		header: "Viewing file: ",
	},
};

export default messages;
